import { Navigate } from 'react-router-dom';
import type { UserRole } from '@socialsoup/shared';
import { useAuthStore } from '@/stores/authStore';
import { ROLE_TO_PORTAL } from '@/lib/constants';

interface RoleGuardProps {
  allowed: UserRole[];
  children: React.ReactNode;
}

export function RoleGuard({ allowed, children }: RoleGuardProps) {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowed.includes(user.role)) {
    // Redirect to the user's correct portal
    const correctPath = ROLE_TO_PORTAL[user.role] ?? '/';
    return <Navigate to={correctPath} replace />;
  }

  return <>{children}</>;
}
